module.exports = __webpack_public_path__ + "static/002-abbe0cdd4f8fb02fa05cf118f7db8de7.jpg";